import React, { useState, useEffect } from "react";
import { Line, PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
// import MonthlyQuotation from "./MonthlyQuotationTemplate/MonthlyQuotation";
import { CgSpinner } from "react-icons/cg";
import CostPlusPdf from "./CostPlusPdf";
import MonthlyQuotation from "../MonthlyQuotationTemplate/MonthlyQuotation";
import Pdf2 from "../../../../DummyPdfs/Pdf2";

const GenerateCostPlusPDFPopup = ({
  openGenerateQuotation,
  setOpenGenerateQuotation,
  InitialSelectedTItles,
  setGeneratedTitles,
  list,
  TableRowLists,
}) => {
  ///////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////
  // const HEADERS_DATA = list?.quotation_cost_sheet_heading;
  // const HEADERS_LENGTH = HEADERS_DATA.length;
  // const BASIC_INFO = list?.quotation_cost_sheet_basic_info;
  // const COST_DETAILS = list?.quotation_cost_sheet_cost_details;

  // let empHeaders = [
  //   "Quotation ID",
  //   "Actual Profession",
  //   "Visa Profession",
  //   "Profession Level",
  //   "Gender",
  //   "Nationality",
  //   "Quantity",
  // ]; // these are fixed columns
  // let fixedHeadersCount = empHeaders.length;
  // const headers = [];
  // const data = [];
  // for (let i = 0; i < BASIC_INFO.length; i++) {
  //   let profession = BASIC_INFO[i]?.profession_level;
  //   let item = {
  //     quotation_cost_sheet_profession_basic_information_id: BASIC_INFO[i].id,
  //     quotation_id: BASIC_INFO[i]?.quotation_id,
  //     actual_profession: BASIC_INFO[i]?.job_position?.name,
  //     visa_profession: BASIC_INFO[i]?.visa_profession?.name,
  //     profession_Level: BASIC_INFO[i]?.profession_level?.name,
  //     gender: BASIC_INFO[i]?.gender,
  //     nationality: BASIC_INFO[i]?.nationality?.name,
  //     quantity: BASIC_INFO[i]?.quantity,
  //     "Monthly Fee (each) (including NItakat, Admin and SL Service Fee) (SAR)":
  //       parseInt(profession?.admin_fee) +
  //       parseInt(profession?.nitakat) +
  //       parseInt(profession?.soundline_fee),
  //   };
  //   data.push(item);
  // }
  // const result = [];
  // const rateCategoryMap = {};
  // HEADERS_DATA.forEach((heading) => {
  //   rateCategoryMap[heading.id] = heading?.rate_category?.name;
  // });

  // COST_DETAILS.forEach((costDetail) => {
  //   const {
  //     quotation_cost_sheet_profession_basic_information_id,
  //     quotation_cost_sheet_heading_id,
  //     cost,
  //   } = costDetail;
  //   const head = HEADERS_DATA.find(
  //     (heading) => heading.id === quotation_cost_sheet_heading_id
  //   );
  //   let heading;
  //   if (head?.type === "Default") {
  //     heading = head?.rate_category_item?.name;
  //   } else {
  //     heading = head?.rate_category_item_name;
  //   }
  //   const rateCategory = rateCategoryMap[quotation_cost_sheet_heading_id];
  //   let professionEntry = result.find(
  //     (entry) =>
  //       entry.quotation_cost_sheet_profession_basic_information_id ===
  //       quotation_cost_sheet_profession_basic_information_id
  //   );
  //   if (!professionEntry) {
  //     professionEntry = {
  //       quotation_cost_sheet_profession_basic_information_id,
  //       data: [],
  //     };
  //     result.push(professionEntry);
  //   }

  //   professionEntry.data.push({
  //     heading,
  //     cost,
  //     rate_category: rateCategory,
  //   });
  // });

  // for (let i = 0; i < HEADERS_LENGTH; i++) {
  //   const qcs = HEADERS_DATA[i];
  //   let head =
  //     qcs.type === "Default"
  //       ? qcs.rate_category_item?.name
  //       : qcs.rate_category_item_name;
  //   let rateCategory = qcs?.rate_category?.name;

  //   if (rateCategory === "Employee Salary Package") {
  //     if (!empHeaders.includes(head)) empHeaders.push(head);
  //   }
  // }
  // headers.push(...[...empHeaders]);

  // const combinedData = data.map((item1) => {
  //   const item2 = result.find(
  //     (item) =>
  //       item.quotation_cost_sheet_profession_basic_information_id ===
  //       item1.quotation_cost_sheet_profession_basic_information_id
  //   );

  //   if (item2) {
  //     return {
  //       ...item1,
  //       data: item2.data,
  //     };
  //   } else {
  //     return item1;
  //   }
  // });

  // combinedData.forEach((item) => {
  //   // Extract the data array from the current item
  //   const data = item?.data;

  //   // Initialize a variable to store the total cost
  //   let totalCost = 0;

  //   // Iterate through the data array and sum the costs
  //   data?.forEach((dataItem) => {
  //     // Convert the cost to a number and add it to the totalCost
  //     totalCost += parseFloat(dataItem?.cost);
  //   });

  //   // Create a new object for the "TOTAL MONTHLY PER HEAD COST"
  //   const totalMonthlyCost = {
  //     heading: "TOTAL MONTHLY PER HEAD COST",
  //     cost: totalCost.toFixed(2), // Round to 2 decimal places
  //     rate_category: "Employee Salary Package",
  //   };

  //   // Push the totalMonthlyCost object to the data array
  //   data?.push(totalMonthlyCost);
  // });

  // ///////////////////////////////////////////////////////////
  // ///////////////////////////////////////////////////////////
  // ///////////////////////////////////////////////////////////

  // const [disableCheckbox, setDisableCheckbox] = useState(false);
  // const [onChangeValue, setOnchangeValue] = useState({ obj: {}, value: "" });
  // const [FEES_PAYABLE, SET_FEES_PAYABLE] = useState([]);
  // const [MUQEEM_POINTS, SET_MUQEEM_POINTS] = useState([]);

  // const [costPlusHeadings, setCostPlusHeadings] = useState([
  //   {
  //     col: "ACTUAL PROFESSION",
  //     title: "actual_profession",
  //     basic: true,
  //   },
  //   {
  //     col: "VISA PROFESSION",
  //     title: "visa_profession",
  //     basic: true,
  //   },
  //   {
  //     col: "PROFESSION LEVEL",
  //     title: "profession_Level",
  //     basic: true,
  //   },
  //   {
  //     col: "GENDER",
  //     title: "gender",
  //     basic: true,
  //   },
  //   {
  //     col: "NATIONALITY",
  //     title: "nationality",
  //     basic: true,
  //   },
  //   {
  //     col: "QUANTITY",
  //     title: "quantity",
  //     basic: true,
  //   },
  //   {
  //     col: "Salary",
  //     title: "Salary",
  //   },
  //   {
  //     col: "Monthly Fee (each) (including NItakat, Admin and SL Service Fee) (SAR)",
  //     title:
  //       "Monthly Fee (each) (including NItakat, Admin and SL Service Fee) (SAR)",
  //   },
  // ]);
  // const [GenerateList, setGenerateList] = useState([
  //   ...costPlusHeadings,
  //   {
  //     col: "TOTAL MONTHLY PER HEAD COST",
  //     title: "TOTAL MONTHLY PER HEAD COST",
  //   },
  // ]);

  // useEffect(() => {
  //   const costPlusHeadingArray = costPlusHeadings.map((detail) =>
  //     String(detail.title).toLowerCase()
  //   );
  //   const CPcostSheetHeadings = list?.quotation_cost_sheet_heading?.map(
  //     (heading) => {
  //       return {
  //         col: heading.rate_category_item_name,
  //         title: heading.rate_category_item_name,
  //       };
  //     }
  //   );

  //   // // Filter out duplicates based on the 'col' property
  //   const uniqueCPcostSheetHeadings = CPcostSheetHeadings.filter(
  //     (heading, index, self) =>
  //       index ===
  //       self.findIndex(
  //         (h) =>
  //           h.col === heading.col &&
  //           !costPlusHeadingArray.includes(String(h.col).toLowerCase())
  //       )
  //   );
  //   console.log(uniqueCPcostSheetHeadings, "unique");

  //   setCostPlusHeadings([
  //     ...costPlusHeadings,
  //     ...uniqueCPcostSheetHeadings,
  //     { col: "TOTAL MONTHLY PER HEAD COST", title: "total_monthly_charges" },
  //   ]);

  //   SET_FEES_PAYABLE(list?.quotation_fees_payable);
  //   SET_MUQEEM_POINTS(list?.quotation_muqeem_point);
  // }, [list]);

  // useEffect(() => {
  //   const name = onChangeValue.obg?.col;
  //   const value = onChangeValue.value;
  //   if (GenerateList.length >= 9 && value === true) {
  //     setDisableCheckbox(true);
  //     const filteredArray = GenerateList.filter((item) => item?.col !== name);
  //     setGenerateList(filteredArray);
  //   } else {
  //     setDisableCheckbox(false);
  //     if (value === true) {
  //       setGenerateList((prev) => [...prev, onChangeValue.obg]);
  //     } else {
  //       const filteredArray = GenerateList.filter((item) => item?.col !== name);
  //       setGenerateList(filteredArray);
  //     }
  //   }
  // }, [onChangeValue]);

  // const OnChangeHandler = (value, item) => {
  //   setOnchangeValue({ obg: item, value: value });
  // };

  const HEADERS_DATA = list?.quotation_cost_sheet_heading;
  const HEADERS_LENGTH = HEADERS_DATA.length;
  const BASIC_INFO = list?.quotation_cost_sheet_basic_info;
  const COST_DETAILS = list?.quotation_cost_sheet_cost_details;

  let empHeaders = [
    "Quotation ID",
    "Actual Profession",
    "Visa Profession",
    "Profession Level",
    "Gender",
    "Nationality",
    "Quantity",
  ];
  let fixedHeadersCount = empHeaders.length;
  const headers = [];
  const data = [];

  for (let i = 0; i < BASIC_INFO.length; i++) {
    let profession = BASIC_INFO[i]?.profession_level;
    let item = {
      quotation_cost_sheet_profession_basic_information_id: BASIC_INFO[i].id,
      quotation_id: BASIC_INFO[i]?.quotation_id,
      actual_profession: BASIC_INFO[i]?.job_position?.name,
      visa_profession: BASIC_INFO[i]?.visa_profession?.name,
      profession_Level: BASIC_INFO[i]?.profession_level?.name,
      gender: BASIC_INFO[i]?.gender,
      nationality: BASIC_INFO[i]?.nationality?.name,
      quantity: BASIC_INFO[i]?.quantity,
      "Monthly Fee (each) (including NItakat, Admin and SL Service Fee) (SAR)":
        parseInt(profession?.admin_fee || 0) +
        parseInt(profession?.nitakat || 0) +
        parseInt(profession?.soundline_fee || 0),
    };
    data.push(item);
  }

  const result = [];
  const rateCategoryMap = {};
  HEADERS_DATA.forEach((heading) => {
    rateCategoryMap[heading.id] = heading?.rate_category?.name;
  });

  COST_DETAILS.forEach((costDetail) => {
    const {
      quotation_cost_sheet_profession_basic_information_id,
      quotation_cost_sheet_heading_id,
      cost,
    } = costDetail;

    const head = HEADERS_DATA.find(
      (heading) => heading.id === quotation_cost_sheet_heading_id
    );

    let heading;
    if (head?.type === "Default") {
      heading = head?.rate_category_item?.name;
    } else {
      heading = head?.rate_category_item_name;
    }

    const rateCategory = rateCategoryMap[quotation_cost_sheet_heading_id];

    let professionEntry = result.find(
      (entry) =>
        entry.quotation_cost_sheet_profession_basic_information_id ===
        quotation_cost_sheet_profession_basic_information_id
    );

    if (!professionEntry) {
      professionEntry = {
        quotation_cost_sheet_profession_basic_information_id,
        data: [],
      };
      result.push(professionEntry);
    }

    professionEntry.data.push({
      heading,
      cost,
      rate_category: rateCategory,
    });
  });

  for (let i = 0; i < HEADERS_LENGTH; i++) {
    const qcs = HEADERS_DATA[i];
    let head =
      qcs.type === "Default"
        ? qcs.rate_category_item?.name
        : qcs.rate_category_item_name;
    let rateCategory = qcs?.rate_category?.name;

    if (rateCategory === "Employee Salary Package") {
      if (!empHeaders.includes(head)) empHeaders.push(head);
    }
  }

  headers.push(...empHeaders);

  const combinedData = data.map((item1) => {
    const item2 = result.find(
      (item) =>
        item.quotation_cost_sheet_profession_basic_information_id ===
        item1.quotation_cost_sheet_profession_basic_information_id
    );

    if (item2) {
      return {
        ...item1,
        data: item2.data,
      };
    } else {
      return item1;
    }
  });

  combinedData.forEach((item) => {
    const data = item?.data;
    let totalCost = 0;

    data?.forEach((dataItem) => {
      totalCost += parseFloat(dataItem?.cost || 0);
    });

    const totalMonthlyCost = {
      heading: "TOTAL MONTHLY PER HEAD COST",
      cost: totalCost.toFixed(2),
      rate_category: "Employee Salary Package",
    };

    data?.push(totalMonthlyCost);
  });
  console.log("print the value in console", combinedData);

  combinedData.forEach((item) => {
    const totalCostItem = item?.data?.find(
      (entry) => entry.heading === "TOTAL MONTHLY PER HEAD COST"
    );
    const totalSalaryCost = item?.data?.find(
      (entry) => entry.heading === "Salary"
    );
    console.log("total salary....", totalSalaryCost);
    if (totalCostItem) {
      item[
        "Monthly Fee (each) (including NItakat, Admin and SL Service Fee) (SAR)"
      ] =
        totalCostItem.cost -
        parseInt(totalSalaryCost.cost ? totalSalaryCost.cost : 0);
    }
  });

  // -----------------------------------------------------------
  // State & useEffect logic (React)
  const [disableCheckbox, setDisableCheckbox] = useState(false);
  const [onChangeValue, setOnchangeValue] = useState({ obg: {}, value: "" });
  const [FEES_PAYABLE, SET_FEES_PAYABLE] = useState([]);
  const [MUQEEM_POINTS, SET_MUQEEM_POINTS] = useState([]);

  const [costPlusHeadings, setCostPlusHeadings] = useState([
    { col: "ACTUAL PROFESSION", title: "actual_profession", basic: true },
    { col: "VISA PROFESSION", title: "visa_profession", basic: true },
    { col: "PROFESSION LEVEL", title: "profession_Level", basic: true },
    { col: "GENDER", title: "gender", basic: true },
    { col: "NATIONALITY", title: "nationality", basic: true },
    { col: "QUANTITY", title: "quantity", basic: true },
    { col: "Salary", title: "Salary" },
    {
      col: "Monthly Fee (each) (including NItakat, Admin and SL Service Fee) (SAR)",
      title:
        "Monthly Fee (each) (including NItakat, Admin and SL Service Fee) (SAR)",
    },
  ]);

  const [GenerateList, setGenerateList] = useState([
    ...costPlusHeadings,
    {
      col: "TOTAL MONTHLY PER HEAD COST",
      title: "TOTAL MONTHLY PER HEAD COST",
    },
  ]);

  useEffect(() => {
    const costPlusHeadingArray = costPlusHeadings.map((detail) =>
      String(detail.title).toLowerCase()
    );

    const CPcostSheetHeadings = list?.quotation_cost_sheet_heading?.map(
      (heading) => {
        return {
          col: heading.rate_category_item_name,
          title: heading.rate_category_item_name,
        };
      }
    );

    const uniqueCPcostSheetHeadings = CPcostSheetHeadings.filter(
      (heading, index, self) =>
        index ===
        self.findIndex(
          (h) =>
            h.col === heading.col &&
            !costPlusHeadingArray.includes(String(h.col).toLowerCase())
        )
    );

    setCostPlusHeadings([
      ...costPlusHeadings,
      ...uniqueCPcostSheetHeadings,
      { col: "TOTAL MONTHLY PER HEAD COST", title: "total_monthly_charges" },
    ]);

    SET_FEES_PAYABLE(list?.quotation_fees_payable);
    SET_MUQEEM_POINTS(list?.quotation_muqeem_point);
  }, [list]);

  useEffect(() => {
    const name = onChangeValue.obg?.col;
    const value = onChangeValue.value;
    if (GenerateList.length >= 9 && value === true) {
      setDisableCheckbox(true);
      const filteredArray = GenerateList.filter((item) => item?.col !== name);
      setGenerateList(filteredArray);
    } else {
      setDisableCheckbox(false);
      if (value === true) {
        setGenerateList((prev) => [...prev, onChangeValue.obg]);
      } else {
        const filteredArray = GenerateList.filter((item) => item?.col !== name);
        setGenerateList(filteredArray);
      }
    }
  }, [onChangeValue]);

  const OnChangeHandler = (value, item) => {
    setOnchangeValue({ obg: item, value: value });
  };

  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        openGenerateQuotation ? "flex" : "hidden"
      }`}
    >
      <form className="max-w-3xl w-full h-auto bg-white  rounded-md p-5">
        <h2 className="text-lg font-bold">CHOOSE FIELDS</h2>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <p className="text-sm uppercase">select fields between 3 to 9</p>
          <p className="text-xs font-semibold text-slate-600">
            {GenerateList.length}/ 9 SELECTED
          </p>
        </div>
        <div className="my-4 grid grid-cols-2 gap-2 uppercase">
          {costPlusHeadings?.map((item, index) => (
            <div key={index} className="form-control w-fit">
              <label className="cursor-pointer label">
                <input
                  disabled={
                    disableCheckbox &&
                    !GenerateList.some((check) => check.col == item.col)
                  }
                  onChange={(e) => OnChangeHandler(e.target.checked, item)}
                  type="checkbox"
                  checked={GenerateList.some((check) => check.col == item.col)}
                  className="checkbox  checkbox-accent"
                  // title={`${
                  //   item.col === "TOTAL MONTHLY PER HEAD COST"
                  //     ? "TOTAL MONTHLY PER HEAD COST CAN'T BE UNSELECTED"
                  //     : ""
                  // }`}
                />
                <span className="label-text ml-2 font-semibold font-lg">
                  {item.col}
                </span>
              </label>
            </div>
          ))}
        </div>
        <div className="flex gap-3 justify-center items-center m-5">
          <button
            className="p-2 w-20 rounded-md ring-1 ring-slate-600"
            onClick={() => {
              setOpenGenerateQuotation(false);
            }}
          >
            CANCEl
          </button>
          {list?.quotation_type === "Cost Plus" &&
          GenerateList.length >= 3 &&
          GenerateList.length <= 9 ? (
            <button
              type="button"
              onClick={() =>
                setTimeout(() => {
                  setOpenGenerateQuotation(false);
                })
              }
              className="p-2 bg-blue text-white rounded-md"
            >
              <PDFDownloadLink
                document={
                  <CostPlusPdf
                    combinedData={combinedData}
                    BASIC_DATA={data}
                    generatedTitles={GenerateList}
                    quotationDetails={list}
                    FEES_PAYABLE={FEES_PAYABLE}
                    MUQEEM_POINTS={MUQEEM_POINTS}
                    TERMS={list?.terms_and_condition}
                    NOTES={list?.notes}
                    QUOTATION={list?.quotation}
                  />
                }
                fileName="costplus.pdf"
              >
                {({ blob, url, loading, error }) =>
                  loading ? (
                    <p className="flex gap-3 items-center">
                      Submit
                      {/* <CgSpinner className="animate-spin mx-auto" /> */}
                    </p>
                  ) : (
                    <p className="flex gap-3 items-center">Submit</p>
                  )
                }
              </PDFDownloadLink>
            </button>
          ) : (
            <button
              className="p-2 bg-blue text-white rounded-md opacity-50"
              disabled
            >
              Submit
            </button>
          )}
        </div>
      </form>
      {/* <PDFViewer className="w-full min-h-screen">
        <CostPlusPdf
          combinedData={combinedData}
          QUOTATION={list?.quotation}
          generatedTitles={GenerateList}
          quotationDetails={list}
          FEES_PAYABLE={FEES_PAYABLE}
          MUQEEM_POINTS={MUQEEM_POINTS}
          TERMS={list?.terms_and_condition}
        />
      </PDFViewer> */}
    </div>
  );
};

export default GenerateCostPlusPDFPopup;
